const STORAGE_KEY = 'hypnose-cle-stats';

const getStats = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { sessions: [], dailyGoal: 600 };
    return JSON.parse(raw);
  } catch { return { sessions: [], dailyGoal: 600 }; }
};

const saveStats = (stats) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(stats));
};

export const recordSession = (mode, durationSeconds, program = null) => {
  if (durationSeconds < 10) return; // Ignorer les sessions < 10s
  const stats = getStats();
  stats.sessions.push({
    date: new Date().toISOString().split('T')[0],
    mode,
    duration: Math.round(durationSeconds),
    program,
    timestamp: Date.now()
  });
  // Garder uniquement les 90 derniers jours
  const cutoff = Date.now() - 90 * 24 * 60 * 60 * 1000;
  stats.sessions = stats.sessions.filter(s => s.timestamp > cutoff);
  saveStats(stats);
};

export const getDailyGoal = () => getStats().dailyGoal;

export const setDailyGoal = (seconds) => {
  const stats = getStats();
  stats.dailyGoal = seconds;
  saveStats(stats);
};

export const getTodayTotal = () => {
  const today = new Date().toISOString().split('T')[0];
  const stats = getStats();
  return stats.sessions
    .filter(s => s.date === today)
    .reduce((sum, s) => sum + s.duration, 0);
};

export const getTodaySessions = () => {
  const today = new Date().toISOString().split('T')[0];
  return getStats().sessions.filter(s => s.date === today);
};

export const getWeekTotal = () => {
  const now = new Date();
  const weekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
  return getStats().sessions
    .filter(s => s.date >= weekAgo)
    .reduce((sum, s) => sum + s.duration, 0);
};

export const getMonthTotal = () => {
  const now = new Date();
  const monthStart = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-01`;
  return getStats().sessions
    .filter(s => s.date >= monthStart)
    .reduce((sum, s) => sum + s.duration, 0);
};

export const getStreak = () => {
  const stats = getStats();
  const dates = [...new Set(stats.sessions.map(s => s.date))].sort().reverse();
  if (dates.length === 0) return 0;
  
  const today = new Date().toISOString().split('T')[0];
  const yesterday = new Date(Date.now() - 86400000).toISOString().split('T')[0];
  
  // La série doit commencer aujourd'hui ou hier
  if (dates[0] !== today && dates[0] !== yesterday) return 0;
  
  let streak = 1;
  for (let i = 0; i < dates.length - 1; i++) {
    const current = new Date(dates[i]);
    const prev = new Date(dates[i + 1]);
    const diff = (current - prev) / 86400000;
    if (diff === 1) streak++;
    else break;
  }
  return streak;
};

export const getLast30Days = () => {
  const stats = getStats();
  const days = [];
  for (let i = 29; i >= 0; i--) {
    const date = new Date(Date.now() - i * 86400000).toISOString().split('T')[0];
    const daySessions = stats.sessions.filter(s => s.date === date);
    const total = daySessions.reduce((sum, s) => sum + s.duration, 0);
    days.push({ date, total, sessions: daySessions.length });
  }
  return days;
};

export const getModeStats = () => {
  const stats = getStats();
  const breathing = stats.sessions.filter(s => s.mode === 'breathing');
  const bodyscan = stats.sessions.filter(s => s.mode === 'bodyscan');
  return {
    breathing: { count: breathing.length, total: breathing.reduce((s, x) => s + x.duration, 0) },
    bodyscan: { count: bodyscan.length, total: bodyscan.reduce((s, x) => s + x.duration, 0) }
  };
};

export const formatDuration = (seconds) => {
  if (seconds < 60) return `${seconds}s`;
  const mins = Math.floor(seconds / 60);
  if (mins < 60) return `${mins}min`;
  const hours = Math.floor(mins / 60);
  const remainMins = mins % 60;
  return remainMins > 0 ? `${hours}h${remainMins}` : `${hours}h`;
};
